<script setup lang="ts">
import {computed} from 'vue';
import {useStore} from '../store';
import {FrameColour} from '../types';

const store = useStore();

const tFrameColour = computed(() => VisualiserConfig.locale === 'au'
    ? 'Frame colour'
    : 'Frame color');

const tColour = computed(() => VisualiserConfig.locale === 'au'
    ? 'Colour'
    : 'Color');

const options = computed(() =>
    VisualiserConfig.locale === 'au'
        ? [
            {value: FrameColour.Black, label: 'Black', swatch: '#000'},
            {value: FrameColour.Monument, label: 'Monument', swatch: '#434343'},
            {value: FrameColour.WoodlandGrey, label: 'Woodland Grey', swatch: '#656c6d'},
            {value: FrameColour.Paperbark, label: 'Paperbark', swatch: '#decbae'},
            {value: FrameColour.ClassicCream, label: 'Classic Cream', swatch: '#f0e5bf'},
            {value: FrameColour.SurfMist, label: 'Surf Mist', swatch: '#d6d6cc'},
            {value: FrameColour.PureWhite, label: 'Pure White', swatch: '#fff'},
        ]
        : [
            {value: FrameColour.Black, label: 'Black', swatch: '#000'},
            {value: FrameColour.Bronze, label: 'Bronze', swatch: '#554e52'},
            {value: FrameColour.WoodlandGrey, label: 'Woodland Gray', swatch: '#656c6d'},
            {value: FrameColour.Paperbark, label: 'Paperbark', swatch: '#decbae'},
            {value: FrameColour.PureWhite, label: 'Pure White', swatch: '#fff'},
        ]);

const currentLabel = computed(() => options.value.find(o => o.value === store.frameColour)?.label);
</script>

<template>
    <div class="visualiser-controls-main">
        <div class="visualiser-controls-main-label-sm">{{ tFrameColour }}: {{ currentLabel }}</div>
        <div class="visualiser-controls-main-label-lg">Frame</div>
        <div class="visualiser-controls-main-info">{{ tColour }} : {{ currentLabel }}</div>
        <div class="visualiser-controls-main-grid">
            <div
                v-for="{value, swatch} in options"
                :class="['visualiser-controls-main-grid-option', store.frameColour === value && 'active']"
                @click="store.frameColour = value"
            >
                <div :style="{['background-color']: swatch}" class="visualiser-controls-main-grid-swatch" />
            </div>
        </div>
    </div>
</template>
